export function timeslotTimes(timeslot, availability = [], maxCapacity = 0, isDateToday = false) {
    let startSplit = timeslot.start.split(":");
    let endSplit = timeslot.end.split(":");
    let startTime = Number(startSplit[0]) * 60 + Number(startSplit[1]);
    let interval = timeslot.intervals || 10;
    let duration = timeslot.duration || timeslot.time || 60;
    if (isDateToday) {
        const now = new Date();
        let nowTime = now.getHours() * 60 + now.getMinutes();
        if (nowTime > startTime) {
            while (startTime < nowTime) {
                startTime += interval;
            }
        }
    }
    let endTime = Number(endSplit[0]) * 60 + Number(endSplit[1]);
    let times = [];
    for (let i = startTime; i < endTime; i += interval) {
        if (i + duration > endTime) break;
        let hour = Math.floor(i / 60);
        let minute = i % 60;
        let available = maxCapacity;
        for (let seg of availability) {
            let segStartParts = seg.start.split(":");
            let segEndParts = seg.end.split(":");
            let segStart = Number(segStartParts[0]) * 60 + Number(segStartParts[1]);
            let segEnd = Number(segEndParts[0]) * 60 + Number(segEndParts[1]);
            if (i < segEnd && (i + duration) > segStart) {
                available = Math.min(available, seg.available);
                if (available === 0) break;
            }
        }
        let timeStr = hour.toString().padStart(2, "0") + ":" + minute.toString().padStart(2, "0");
        times.push({ available, time: timeStr });
    }
    return times;
}
